<template>
  <div
    class="z2-tag fw-300 pointer"
    :style="
      !inactive ? { color: 'white', 'background-color': data.color } : { color: data.color, 'background-color': 'white', border: 'thin solid ' + data.color }
    ">
    <span
      class="trim-text-1-line"
      :style="{ 'max-width': maxWidthName, 'font-weight': 500 }">
      {{ nameTag }}
    </span>
  </div>
</template>

<script>
export default {
  props: ["data", "inactive"],
  computed: {
    maxWidthName() {
      return "172px";
    },
    // showTag() {
    //   let filter = this.app.tags.filter((t) => t.id == this.data.id);
    //   if (filter && filter.length > 0) return true;
    //   return false;
    // },
    nameTag() {
      return this.data.assign ? "* " + this.data.name : this.data.name;
    },
  },
  mounted() {},
};
</script>

<style>
</style>